import { render } from "./MergedSimilarItemsModal.vue?vue&type=template&id=0480d0d5&scoped=true"
import script from "./MergedSimilarItemsModal.vue?vue&type=script&lang=js"
export * from "./MergedSimilarItemsModal.vue?vue&type=script&lang=js"

import "./MergedSimilarItemsModal.vue?vue&type=style&index=0&id=0480d0d5&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0480d0d5"]])

export default __exports__